import React, {memo} from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

/* Styles */
import s from './product-card.scss'

const ProductTitle = memo(({brand, name, isProduct}) => (
  <div className={isProduct ? s.title : cx(s.title, s.titleListing)}>
    {name}
  </div>
))

ProductTitle.propTypes = {
  brand: PropTypes.string,
  name: PropTypes.string,
}

export default ProductTitle
